import { AuthGuard } from '@sudoplatform-private/admin-web-ui'
import { AuthGroups, Service } from '@sudoplatform-private/admin-web-utils'
import React from 'react'
import { Navigate, Route } from 'react-router'
import { ProjectPage } from '../containers/Project/ProjectPage'
import { NewRouteDefinition } from './route-definition'

export const CONSOLE_ROOT_PATH = '/console'
export const PROJECT_ROOT_PATH = '/console/project/:projectId'

interface BuildRoutesArgs {
  routes: NewRouteDefinition[]
  authGroups: AuthGroups | undefined
  retryPath?: string
}

export function buildRoutes(args: BuildRoutesArgs): React.ReactElement[] {
  const loginPath = args.retryPath ? `/login?ret=${args.retryPath}` : '/login'

  return args.routes.map((route) => {
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          <AuthGuard
            authGroups={args.authGroups}
            required={route.requiredAuth}
            noAuthFallback={<Navigate to={loginPath} />}
          >
            {route.element}
          </AuthGuard>
        }
      />
    )
  })
}

interface BuildProjectRoutesArgs {
  routes: NewRouteDefinition[]
  authGroups: AuthGroups
  services: Service[]
  projectId: string | undefined
}

export function buildProjectRoutes(
  args: BuildProjectRoutesArgs,
): (React.ReactElement | null)[] {
  return args.routes.map((route) => {
    const path = route.remoteUrl ? `${route.path}/*` : route.path

    return route?.path ? (
      <Route
        key={route.path}
        path={path}
        element={
          <ProjectPage
            route={route}
            projectId={args.projectId ?? ''}
            authGroups={args.authGroups}
            projectServices={args.services}
          />
        }
      />
    ) : null
  })
}
